import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesGrid() {
  const featured = articles[0];
  const grid = articles.slice(1);

  return (
    <section id="articles" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 text-xs font-medium text-foreground-600 tracking-wide bg-background-50">
            SEO Articles
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            PandabuySpreadsheet Guides &amp; Resources
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-[560px] mx-auto">
            Expert tips, category deep dives, and shopping strategies to get the most out of every Pandabuy Spreadsheet
          </p>
        </div>

        <div className="mb-10">
          <Link
            to={`/article/${featured.slug}`}
            className="group block rounded-3xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
          >
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-[42%] flex-shrink-0">
                <div className="h-[280px] md:h-[340px] lg:h-full overflow-hidden">
                  <img
                    src={featured.imageUrl}
                    alt={featured.title}
                    title={featured.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="lg:w-[58%] flex flex-col justify-center p-6 md:p-10">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-50 text-primary-600 text-xs font-semibold tracking-wide w-fit">
                  {featured.tag}
                </span>
                <h3 className="mt-4 font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 leading-[1.18] group-hover:text-primary-600 transition-colors">
                  {featured.title}
                </h3>
                <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed max-w-[560px]">
                  {featured.excerpt}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary-500 group-hover:gap-3 transition-all whitespace-nowrap">
                  Read Full Article
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {grid.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-[11px] font-semibold tracking-wide">
                  {article.tag}
                </span>
                <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950 leading-[1.25] group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-primary-500 group-hover:gap-2 transition-all whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}